<template>
  <div>
    <el-dialog title="处理结果"
      :append-to-body="true"
      :modal-append-to-body="false"
      width="500px"
      v-on="$listeners"
      v-bind="$attrs"
      @close="handleClose">
      <el-form label-width="100px">
        <el-form-item label="订单状态">{{status2cn(resultInfoParam.info)}}</el-form-item>
        <el-form-item label="发放类型">{{resultInfoParam.info.status === 1 ? withdrawTypeMap[resultInfoParam.info.type] : '-'}}
        </el-form-item>
        <el-form-item
          v-if="resultInfoParam.info.status === 1"
          label="备注">{{resultInfoParam.info.remark || '-'}}
        </el-form-item>
        <el-form-item
          v-if="resultInfoParam.info.status === 2"
          label="拒绝原因">{{resultInfoParam.info.reject_reason || '-'}}
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {withdrawTypeMap} from '../withdraw.const'
import {status2cn} from '../withdraw.utils'

export default {
  props: {
    resultInfoParam: Object,
  },
  data() {
    return {
      withdrawTypeMap,
      status2cn,
    }
  },
  methods: {
    // 关闭
    handleClose() {
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
